export type HttpResponse<T> = {
  data: T[]
  meta?: any
}

export const httpUtil = {}
